import type { GrpcErrorResponseBody } from '@web-platform/shared-universal-types/src/network/types';

export const shimIntoNetworkResponseSuccess = <Res extends Record<string, unknown>>(
  response: Res,
) => ({
  error: false as const,
  headers: {},
  body: response,
  status: 200,
});

export const shimIntoNetworkResponseError = (
  body: GrpcErrorResponseBody,
  status: number = 500,
) => ({
  error: true as const,
  headers: null,
  body,
  status,
});
